import { defineMessages } from 'react-intl';

export default defineMessages({
  firstHelpItemCaption: 'Stable Interest',
  firstHelpItemDescription:
    'Your interest rate will {stay} for the duration of your loan. Recommended for long-term loan periods and for users who prefer predictability.',
  stayTheSame: 'stay the same',
  secondHelpItemCaption: 'Variable Interest',
  secondHelpItemDescription:
    'Your interest rate will {fluctuate} based on the market. Recommended for short-term loans.',
  fluctuate: 'fluctuate',
});
